export default __webpack_public_path__ + "static/media/grinScopeInfo.5e6fadc5.png";